module.exports = "https://www.gc-qa.gnp.com.mx/001cafb72c68cd648972d2bb8089f236.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-7.png
// module id = 955
// module chunks = 0 1